<div class="planning-grid">

  <app-scrollable class="planning-grid__scroll" axis="both">
    <table class="planning-grid__table" role="grid" [attr.aria-label]="'PLANNING.DELIVERY' | translate">

      <thead>
        <tr>
          <th class="planning-grid__sticky-left planning-grid__corner" rowspan="2" scope="col">
            <app-input
              class="planning-grid__search"
              type="search"
              [placeholder]="'GLOBAL.RECHERCHER' | translate"
              [clearable]="true"
              [ngModel]="searchTerm()"
              (ngModelChange)="searchTerm.set($event)"
              data-attr="area-planning-delivery-search">
              <img slot="icon-left" src="assets/icon/new_icon/search.svg" alt="" />
            </app-input>
          </th>

          @for (group of dayGroups(); track group.date) {
            <th
              class="planning-grid__day"
              [attr.colspan]="group.shiftCount"
              [class.is-today]="group.isToday"
              [class.has-selected-shift]="isDaySelected(group.date)"
              [style.min-width.px]="cellWidthPx() * group.shiftCount"
              scope="colgroup">
              <span class="planning-grid__weekday">{{ group.weekday }}</span>
              <span class="planning-grid__day-number">{{ group.dayNumber }}</span>
            </th>
          }

          <th class="planning-grid__sticky-right planning-grid__totals-head" rowspan="2" scope="col">
            {{ 'PLANNING.TOTALS' | translate }}
          </th>
        </tr>

        <tr>
          @for (col of shiftColumns(); track col.id) {
            <th
              class="planning-grid__shift planning-grid__shift--selectable"
              [class.is-day-start]="col.shiftIndex === 0"
              [class.is-day-shift]="col.kind === 'day'"
              [class.is-today]="col.isToday"
              [class.is-selected]="isShiftSelected(col)"
              [style.width.px]="cellWidthPx()"
              [style.min-width.px]="cellWidthPx()"
              [attr.aria-pressed]="isShiftSelected(col)"
              [title]="col.shiftLabel + ' — ' + ('PLANNING.SELECT_SHIFT' | translate)"
              scope="col"
              tabindex="0"
              (click)="shiftToggle.emit(col)"
              (keydown.enter)="shiftToggle.emit(col)"
              (keydown.space)="shiftToggle.emit(col); $event.preventDefault()">
              <app-shift-icon [kind]="col.kind" />
            </th>
          }
        </tr>
      </thead>

      <tbody>
        @for (row of visibleRows(); track row.blastId) {
          @let totals = getTotals(row);
          <tr>
            <td class="planning-grid__sticky-left planning-grid__label" [title]="row.zone" (click)="rowClick.emit(row)">
              <div class="planning-grid__name">{{ row.label }}</div>
              <div class="planning-grid__meta">
                {{ 'PLANNING.HOLES_LOADED_KG' | translate: { holes: row.blastHoleCount, kg: (totals.loadedKg | number:'1.0-0') } }}
              </div>
            </td>

            @for (col of shiftColumns(); track col.id) {
              <td
                class="planning-grid__cell"
                [class.is-day-start]="col.shiftIndex === 0"
                [class.is-day-shift]="col.kind === 'day'"
                [class.is-today]="col.isToday"
                [class.is-selected]="isShiftSelected(col)"
                [style.width.px]="cellWidthPx()">
                <app-activity-cell
                  [items]="getItemsForCell(row, col)"
                  [activeId]="activeId()"
                  (itemClick)="openCard($event)" />
              </td>
            }

            <td class="planning-grid__sticky-right planning-grid__totals">
              <div
                class="planning-grid__progress-track"
                role="progressbar"
                [attr.aria-valuenow]="clamp100(totals.holeProgress)"
                aria-valuemin="0"
                aria-valuemax="100">
                <div class="planning-grid__progress-fill" [style.width.%]="clamp100(totals.holeProgress)"></div>
              </div>
              <div class="planning-grid__totals-numbers">
                <span class="planning-grid__percent">{{ totals.holeProgress.toFixed(0) }}%</span>
                <span class="planning-grid__ratio">
                  {{ totals.holesLoaded }}/{{ row.blastHoleCount }} {{ 'PLANNING.HOLES' | translate }}
                </span>
              </div>
            </td>
          </tr>
        }

        <tr class="planning-grid__filler" aria-hidden="true">
          <td class="planning-grid__sticky-left"></td>
          @for (col of shiftColumns(); track col.id) {
            <td
              class="planning-grid__cell"
              [class.is-day-start]="col.shiftIndex === 0"
              [class.is-day-shift]="col.kind === 'day'"
              [class.is-today]="col.isToday"
              [class.is-selected]="isShiftSelected(col)"></td>
          }
          <td class="planning-grid__sticky-right"></td>
        </tr>
      </tbody>

      <tfoot>
        <tr>
          <td class="planning-grid__sticky-left planning-grid__footer-label">
            {{ 'PLANNING.LOADED' | translate }}
          </td>

          @for (col of shiftColumns(); track col.id) {
            @let shiftTotal = getShiftTotal(col);
            <td class="planning-grid__footer-cell" [class.is-selected]="isShiftSelected(col)">
              @if (shiftTotal > 0) { {{ shiftTotal | number:'1.0-0' }}kg } @else { - }
            </td>
          }

          <td class="planning-grid__sticky-right planning-grid__footer-total">
            @let summary = overall();
            <div class="planning-grid__footer-summary">
              <app-progress-ring [percent]="summary.percent" />
              <div>
                <span class="planning-grid__footer-percent">{{ summary.percent.toFixed(0) }}%</span>
                <span class="planning-grid__footer-ratio">
                  {{ summary.holesLoaded }}/{{ summary.holes }} {{ 'PLANNING.HOLES' | translate }}
                </span>
              </div>
            </div>
          </td>
        </tr>
      </tfoot>

    </table>
  </app-scrollable>

</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="cardAnchor() ?? el.nativeElement"
  [cdkConnectedOverlayOpen]="!!activeDelivery()"
  [cdkConnectedOverlayPositions]="cardPositions"
  (overlayOutsideClick)="closeCard()"
  (detach)="closeCard()">
  <app-activity-card
    [title]="'PLANNING.DELIVERY_SESSION' | translate"
    [fields]="cardFields()"
    (seeMore)="onSeeMore()"
    (closed)="closeCard()" />
</ng-template>
